import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import { getModule} from 'vuex-module-decorators';
import nomenclatoare from '@/store/nomenclatoare';
import iDocumentIntrare from '@/types/iDocumentIntrare';
import MyDocuments from '@/components/MyDocuments/MyDocuments.vue';
import WorkDocumenteFaraAtasament from '@/components/WorkDocumenteFaraAtasament/WorkDocumenteFaraAtasament.vue';
import WorkOnDocument from '@/components/WorkOnDocument/WorkOnDocument.vue';
type OrNull<T> = { [K in keyof T]: T[K] | null }
type IDocumentIntrare = OrNull<iDocumentIntrare>;

@Component({components: {MyDocuments, WorkDocumenteFaraAtasament, WorkOnDocument}})
export default class Dashboard extends Vue {
  public taburi: string='documente_repartizate';
  public rightDrawerOpen:boolean = false;
  public nrOfMyDocuments:number=0;
  public $refs: any;
  private storeNomenclatoare = getModule(nomenclatoare);
  public appidDocToWorkOnIt:number=0;
  // private userStore=getModule(User);

  constructor() {
    super();
  }

  public onEventFromMyDocuments(params:any){
    const vueInst = this;
    console.log('onEventFromMyDocuments with params=%o',params)
    switch (params.action) {
      case "updateNrOfMyDocuments" : vueInst.nrOfMyDocuments=params.value;
                                        break;
      case "openDocument" : vueInst.rightDrawerOpen=true;
                              vueInst.appidDocToWorkOnIt=params.value;
                              break;
    }
  }

  public get widthForDrawerDocument(): number{
    if(this.$q.platform.is.mobile) {return window.innerWidth;}
    else{
      return (window.innerWidth-100);
    }
  }

  public mounted() {
    const vueInst = this;
    vueInst.storeNomenclatoare.set_currentpagetitle('Dashboard');
  }
}
